import React from "react";
import "./style.css";

const BloomMadeWith = () => {
  return (
    <div className="new-made-with">
      <span className="new-made-with__text">
        Made with{" "}
        <svg className="new-made-with__heart" viewBox="0 0 24 24" width="12" height="12" aria-hidden="true">
          <path fill="currentColor" d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
        </svg>
        {" "}by Claudiu Popa
      </span>
      <p className="new-made-with__copyright">
        &copy; {new Date().getFullYear()} theoilsbabe. Toate drepturile rezervate.
      </p>
    </div>
  );
};

export default BloomMadeWith;
